import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum BannerType {
	GENERATING_AI_FEEDBACK = 'generating-ai-feedback',
	READ_ONLY = 'read-only',
	MANAGE_AI_MARKERS = 'manage-ai-markers',
	AI_MARKERS_TOUR = 'ai-markers-tour'
}

export interface CommentBanner {
	id: BannerType;
	message: string;
	icon?: string;
	actionText?: string;
	actionCallback?: () => void;
	closeable?: boolean;
	showSpinner?: boolean;
	bgColor?: string;
}

@Injectable({
	providedIn: 'root'
})
export class CommentBannersService {
	private _currentBanner$ = new BehaviorSubject<CommentBanner | null>(null);

	public get currentBanner$ (): Observable<CommentBanner | null> {
		return this._currentBanner$.asObservable();
	}

	public openBanner (banner: CommentBanner): void {
		this.closeBanner();

		this._currentBanner$.next(banner);
	}

	public closeBanner (bannerId?: BannerType): void {
		if (bannerId && this._currentBanner$.value?.id === bannerId) {
			this._currentBanner$.next(null);
		} else if (!bannerId) {
			this._currentBanner$.next(null);
		}
	}

	public isBannerOpen (): boolean {
		return this._currentBanner$.value !== null;
	}

	public getCurrentBanner (): CommentBanner | null {
		return this._currentBanner$.value;
	}

	public showGeneratingAiFeedbackBanner (): void {
		this.openBanner({
			id: BannerType.GENERATING_AI_FEEDBACK,
			message: 'feedback-session-ai-feedback-generating',
			icon: 'ficon-sparkles',
			closeable: false,
			bgColor: '#faf4cc',
			showSpinner: true
		});
	}

	public showReadOnlyBanner (messageKey: string): void {
		this.openBanner({
			id: BannerType.READ_ONLY,
			message: messageKey,
			closeable: false,
			bgColor: '#FCEAE6'
		});
	}

	public showManageAiMarkersTour (actionCallback: () => void): void {
		this.openBanner({
			id: BannerType.MANAGE_AI_MARKERS,
			message: 'feedback-session-feedback-display_manage-ai-markers-tour_message',
			icon: 'ficon-sparkles',
			actionText: 'feedback-session-feedback-display_manage-ai-markers-tour_link',
			actionCallback,
			closeable: true,
			bgColor: '#ebf1f4'
		});
	}

	public showAiMarkersTour (actionCallback: () => void): void {
		this.openBanner({
			id: BannerType.AI_MARKERS_TOUR,
			message: 'feedback-session-feedback-display_ai-markers-tour-text-advanced',
			icon: 'ficon-lightbulb-o',
			actionText: 'feedback-session-feedback-display_ai-markers-tour-button-text',
			actionCallback,
			closeable: true,
			bgColor: '#ebf1f4'
		});
	}
}
